import { API } from '@/api/API';
import { loginAndTransferCart } from '@/state/Cart';
const OTP_AUTH_METHOD = 'otp_ecomm';
export async function requestOTP(payload) {
    const body = { ...payload, provider: 'tix' };
    const response = await API.post('login/request_otp', { body });
    return response.token;
}
export function loginWithOTP(credentials) {
    return loginAndTransferCart(credentials, OTP_AUTH_METHOD);
}
